import api from "./api";
import { gvmPath } from "./apiPaths";

const ENDPOINT_NAME = "/validate";
// No baseURL — the api.js interceptor falls back to
// window.config.REACT_APP_APIGATEWAY when baseURL is absent, so prod/beta/dev
// automatically route to the right gateway host.
const VENDOR_CFG = {
  useVendorToken: true,
} as const;

export type ValidateStepName = "business_details" | "branches" | "review_submit";

export type ValidationFieldError = {
  field: string;
  message: string;
};

export class OnboardingValidationError extends Error {
  errors: ValidationFieldError[];
  constructor(errors: ValidationFieldError[]) {
    super("Onboarding validation failed");
    this.name = "OnboardingValidationError";
    this.errors = errors;
  }
}

export class OnboardingValidateServiceError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "OnboardingValidateServiceError";
  }
}

export async function validateStep(
  step: ValidateStepName,
  taskId: string,
  formData: Record<string, unknown>,
): Promise<void> {
  let response: unknown;
  try {
    response = await api.post(
      gvmPath(ENDPOINT_NAME),
      { step, task_id: taskId, ...formData },
      VENDOR_CFG,
    );
  } catch (err) {
    const status = (err as { response?: { status?: number } })?.response
      ?.status;
    const body = (err as { response?: { data?: unknown } })?.response?.data as
      | { valid?: boolean; errors?: ValidationFieldError[] }
      | undefined;
    if (status === 422 && body && Array.isArray(body.errors)) {
      throw new OnboardingValidationError(body.errors);
    }
    throw err;
  }

  const parsed = response as
    | { valid?: boolean; errors?: ValidationFieldError[] }
    | null;

  if (!parsed || typeof parsed !== "object") {
    throw new OnboardingValidateServiceError(
      "Validation service returned an unexpected response",
    );
  }
  if (parsed.valid === true) return;
  if (parsed.valid === false && Array.isArray(parsed.errors)) {
    throw new OnboardingValidationError(parsed.errors);
  }
  throw new OnboardingValidateServiceError(
    "Validation service response missing the `valid` flag",
  );
}

const vipOnboardingValidate = { validateStep };
export default vipOnboardingValidate;
